export default __webpack_public_path__ + "static/media/green-vaccine-black-virus.fa3a777b.svg";